import { UniquePostInterface } from "@type/locations.types"
import moment from "moment"

export interface TrainingTrackerEmployeeOption {
	_id: string
	firstName: string
	lastName: string
	branch?: string
}

export interface TrainingTrackerBranchOption {
	_id: string
	name: string
}

export interface TrainingTrackerSiteOption {
	_id: string
	name: string
}

export const ALL_FILTER_VALUE = "all"
export const TRAINING_POST_NAME = "Training"

export const TRAINING_TRACKER_FIELDS = {
	BRANCH: "BRANCH",
	EMPLOYEE: "EMPLOYEE",
	SITE: "SITE",
	POST_NAME: "POST_NAME",
	SHIFT_REFERENCE: "SHIFT_REFERENCE",
} as const

export enum ShiftReference {
	FIRST = "FIRST",
	LAST = "LAST",
}

export const SHIFT_REFERENCE_OPTIONS = [
	{ label: "First Shift Worked", value: ShiftReference.FIRST },
	{ label: "Last Shift Worked", value: ShiftReference.LAST },
]

export const isTrainingPostName = (name?: string | null): boolean =>
	(name ?? "").toLowerCase().includes(TRAINING_POST_NAME.toLowerCase())

export const isShiftReferenceDisabled = (postName?: string | null): boolean => isTrainingPostName(postName)

export const isAllFilterValue = (value?: string | null): boolean => !value || value === ALL_FILTER_VALUE

export const buildUniquePostsRequest = (site?: string | null): { site?: string } | Record<string, never> => {
	if (isAllFilterValue(site) || !site) return {}
	return { site }
}

// ! to be deleted
export const isValidDateRange = (startDate?: string | null, endDate?: string | null): boolean => {
	if (!startDate || !endDate) return false
	return !moment(endDate).isBefore(moment(startDate), "day")
}

export const selectedPostStillAvailable = (postName: string | undefined, posts: UniquePostInterface[]): boolean => {
	if (isAllFilterValue(postName)) return true
	return posts.some(post => post.name === postName)
}

export const displayCommentsExactly = (comments: string | null | undefined): string | null | undefined => comments

export const keepAllReportRows = <T>(rows: T[]): T[] => [...rows]

export type TrainingTrackerPayload = {
	startDate: string
	endDate: string
	type: "pdf" | "excel" | string
	includeInactiveEmployee: boolean
	employee?: string
	site?: string
	postName?: string
	shiftReference?: ShiftReference
}

export const sanitizeTrainingTrackerPayload = (payload: Record<string, any>): TrainingTrackerPayload => {
	const result: TrainingTrackerPayload = {
		startDate: payload.startDate,
		endDate: payload.endDate,
		type: payload.type,
		includeInactiveEmployee: Boolean(payload.includeInactiveEmployee),
	}

	if (!isAllFilterValue(payload.employee)) {
		result.employee = payload.employee
	}

	if (!isAllFilterValue(payload.site)) {
		result.site = payload.site
	}

	if (!isAllFilterValue(payload.postName)) {
		result.postName = payload.postName
	}

	if (
		!isShiftReferenceDisabled(result.postName) &&
		(payload.shiftReference === ShiftReference.FIRST || payload.shiftReference === ShiftReference.LAST)
	) {
		result.shiftReference = payload.shiftReference
	}

	return result
}

export const TRAINING_TRACKER_REPORT_PATH = "reports/training-tracker"
export const UNIQUE_POSTS_PATH = "locations/posts/unique"
